import { _ as _baseIsEqualDeep } from "./auth-service-tools707.js";
import { i as isObjectLike_1 } from "./auth-service-tools515.js";
var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;

function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }

  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }

  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;
export { _baseIsEqual as _ };